module.exports = __webpack_public_path__ + "img/17_25.870dbf2a.png";